module.exports = __webpack_public_path__ + "img/share-description.ae47b544.png";